import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RegionForm from '../containers/RegionFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class RegionEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RegionEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('region_route_edit')} />
          <RegionForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RegionEditScreen;

Logger.log('silly', `RegionEditScreen loaded.`);
